<template>
  <flash-message transitionName="fade"
                 class="flashpool"></flash-message>
</template>

<script>
export default {
  data() {
    return {
      maxFlashes: 3,
      flashList: [],
    };
  },
  computed: {
    flashStorage() {
      return this.flash().storage;
    },
  },
  watch: {
    flashStorage() {
      this.syncList();
      this.removeRedundant();
    },
  },
  methods: {
    removeRedundant() {
      const indexIds = this.flashList.map(flash => { return flash.id });

      const numberToRemove = indexIds.length - this.maxFlashes;

      for (let i = 0; i < numberToRemove; i++) {
        const removedItem = this.flashList.shift();
        removedItem.flash.transitionName = null;
        removedItem.flash.destroy();
      }
    },
    syncList() {
      const flashIds = Object.keys(this.flashStorage);
      let indexIds = this.flashList.map(flash => { return flash.id });

      const newFlashIds = flashIds.filter(id => !indexIds.includes(id));

      for (let i = 0; i < newFlashIds.length; i++) {
        const id = newFlashIds[i];
        this.flashList.push({
          id,
          flash: this.flashStorage[id],
        });
      }

      indexIds = this.flashList.map(flash => { return flash.id });

      const redundantListIds = indexIds.filter(id => !indexIds.includes(id))

      this.flashList = this.flashList.filter(listItem => !redundantListIds.includes(listItem.id));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/layout/FlashMessage.vue